(function () {
  'use strict';

  var configuratorRoot = document.querySelector('[data-custom-chopstick-configurator-root]');
  var editor = configuratorRoot && configuratorRoot.querySelector('[data-configurator-editor]');
  if (
    !configuratorRoot ||
    !editor ||
    configuratorRoot.configuratorEditor ||
    !window.Konva ||
    !configuratorRoot.configuratorApp ||
    !configuratorRoot.configuratorDesignDocuments ||
    !configuratorRoot.configuratorDesignRecipes ||
    !configuratorRoot.configuratorLayouts ||
    !configuratorRoot.logoAssets ||
    !configuratorRoot.configuratorProfessionalTemplates ||
    !configuratorRoot.productStage
  ) return;

  var Konva = window.Konva;
  var app = configuratorRoot.configuratorApp;
  var documents = configuratorRoot.configuratorDesignDocuments;
  var designRecipes = configuratorRoot.configuratorDesignRecipes;
  var layouts = configuratorRoot.configuratorLayouts;
  var assetStore = configuratorRoot.logoAssets;
  var professionalTemplates = configuratorRoot.configuratorProfessionalTemplates;
  var productStage = configuratorRoot.productStage;
  var artworkRenderer = configuratorRoot.configuratorArtwork;
  var WIDTH = layouts.artworkSize.width;
  var HEIGHT = layouts.artworkSize.height;
  var SAFE = layouts.safeArea;
  var HISTORY_LIMIT = 30;
  var ROTATION_LIMIT = 180;
  var SNAP_DISTANCE = 12;
  var sideElements = {};
  var status = editor.querySelector('[data-configurator-editor-status]');
  var undoButton = editor.querySelector('[data-configurator-editor-undo]');
  var redoButton = editor.querySelector('[data-configurator-editor-redo]');
  var selectionPanel = editor.querySelector('[data-configurator-editor-inspector]');
  var defaultTools = editor.querySelector('[data-configurator-editor-default-tools]');
  var emptySelection = editor.querySelector('[data-configurator-editor-empty-selection]');
  var textControls = editor.querySelector('[data-configurator-editor-text-controls]');
  var imageControls = editor.querySelector('[data-configurator-editor-image-controls]');
  var textInput = editor.querySelector('[data-configurator-editor-text]');
  var semanticNote = editor.querySelector('[data-configurator-editor-semantic-note]');
  var fontInput = editor.querySelector('[data-configurator-editor-font]');
  var fontSizeInput = editor.querySelector('[data-configurator-editor-font-size]');
  var colorInput = editor.querySelector('[data-configurator-editor-color]');
  var alignInput = editor.querySelector('[data-configurator-editor-align]');
  var boldButton = editor.querySelector('[data-configurator-editor-bold]');
  var italicButton = editor.querySelector('[data-configurator-editor-italic]');
  var textRotationInput = editor.querySelector('[data-configurator-editor-text-rotation]');
  var imageRotationInput = editor.querySelector('[data-configurator-editor-image-rotation]');
  var letterSpacingInput = editor.querySelector('[data-configurator-editor-letter-spacing]');
  var imageInput = editor.querySelector('[data-configurator-editor-image-input]');
  var replaceImageButton = editor.querySelector('[data-configurator-editor-replace-image]');
  var backgroundInput = editor.querySelector('[data-configurator-editor-background]');
  var editorTitle = editor.querySelector('#CustomChopstickConfiguratorEditorTitle');
  var activeSideLabel = editor.querySelector('[data-configurator-editor-active-label]');
  var selectedLabel = editor.querySelector('[data-configurator-editor-selected-label]');
  var objectList = editor.querySelector('[data-configurator-editor-object-list]');
  var stageHost = editor.querySelector('[data-configurator-editor-stage-host]');
  var previewElement = editor.querySelector('.custom-chopstick-configurator-editor__preview');
  var fullscreenButton = editor.querySelector('[data-configurator-editor-fullscreen]');
  var viewButtons = editor.querySelectorAll('[data-configurator-editor-view]');
  var deleteButton = editor.querySelector('[data-configurator-editor-delete]');
  var inspirationHelper = editor.querySelector('.custom-chopstick-configurator-editor-helper');
  var compactQuery = window.matchMedia && window.matchMedia('(max-width: 899px)');
  var stages = { front: null, back: null };
  var active = false;
  var activeSide = 'front';
  var selectedId = null;
  var selectedIds = [];
  var selectedSide = null;
  var resolvedDocument = null;
  var imageElements = {};
  var imageUrls = [];
  var imageUrlByAssetId = {};
  var projectionToken = 0;
  var history = [];
  var historyIndex = -1;
  var internalMutation = false;
  var destroyed = false;
  var objectCounter = 0;
  var pendingImageObjectId = null;
  var imageUploadBusy = false;
  var createdAssetIds = [];
  var unsubscribe = null;
  var resizeObserver = null;
  var fullscreen = false;
  var fullscreenMode = 'none';
  var inlineTextEditor = null;
  var previewTimer = null;
  var inspirationProgrammaticToggle = false;

  if (inspirationHelper) inspirationHelper.open = true;

  Array.prototype.forEach.call(editor.querySelectorAll('[data-configurator-editor-side]'), function (sideElement) {
    var side = sideElement.getAttribute('data-configurator-editor-side');
    sideElements[side] = {
      element: sideElement,
      viewport: sideElement.querySelector('[data-configurator-editor-viewport]'),
      shell: sideElement.querySelector('[data-configurator-editor-canvas-shell]'),
      host: sideElement.querySelector('[data-configurator-editor-canvas]')
    };
  });

  configuratorRoot.setAttribute('data-configurator-editor-initialized', 'true');
  editor.setAttribute('inert', '');

  function clone(value) {
    return JSON.parse(JSON.stringify(value));
  }

  function clamp(value, minimum, maximum) {
    return Math.max(minimum, Math.min(maximum, value));
  }

  function enabledModules(configuration) {
    return configuration.content.enabledTypes || [];
  }

  function allObjects(document) {
    if (!document || !document.sides) return [];
    return document.sides.front.objects.concat(document.sides.back.objects);
  }

  function locateObject(document, objectId) {
    if (!document || !objectId) return null;
    var sides = ['front', 'back'];
    for (var sideIndex = 0; sideIndex < sides.length; sideIndex += 1) {
      var side = sides[sideIndex];
      for (var objectIndex = 0; objectIndex < document.sides[side].objects.length; objectIndex += 1) {
        var object = document.sides[side].objects[objectIndex];
        if (object.id === objectId) return { side: side, index: objectIndex, object: object };
      }
    }
    return null;
  }

  function resolvedObject(objectId) {
    var location = locateObject(resolvedDocument, objectId);
    return location && location.object;
  }

  function documentObject(objectId) {
    var state = app.getState();
    var location = locateObject(state.configuration.design.document, objectId);
    return location && location.object;
  }

  function semanticReferenceIsDirectlyEditable(reference) {
    return [
      'restaurantName',
      'restaurantInfo.address',
      'restaurantInfo.phone',
      'restaurantInfo.contact',
      'message',
      'additionalText'
    ].indexOf(reference) !== -1;
  }

  function documentSnapshot() {
    return app.getState().configuration.design.document;
  }

  function releaseImages() {
    imageUrls.forEach(function (url) { URL.revokeObjectURL(url); });
    imageUrls = [];
    imageUrlByAssetId = {};
    imageElements = {};
  }

  function destroyStages() {
    ['front', 'back'].forEach(function (side) {
      if (stages[side] && stages[side].stage) stages[side].stage.destroy();
      stages[side] = null;
      sideElements[side].host.textContent = '';
    });
    releaseImages();
    resolvedDocument = null;
    selectedId = null;
    selectedIds = [];
    selectedSide = null;
    updateSelectionControls();
    configuratorRoot.setAttribute('data-configurator-editor-stage-count', '0');
  }

  function rectangleForFrame(frame) {
    return {
      x: frame.x * WIDTH,
      y: frame.y * HEIGHT,
      width: frame.width * WIDTH,
      height: frame.height * HEIGHT
    };
  }

  function centeredFrameForSize(frame, width, height) {
    var centerX = frame.x + frame.width / 2;
    var centerY = frame.y + frame.height / 2;
    return {
      x: centerX - width / WIDTH / 2,
      y: centerY - height / HEIGHT / 2,
      width: width / WIDTH,
      height: height / HEIGHT
    };
  }

  function growTextFrame(object, text, stylePatch) {
    var probe = clone(object);
    probe.text = String(text || ' ');
    probe.style = Object.assign({}, probe.style, clone(stylePatch || {}), { fit: 'fixed' });
    if (probe.style.autoGrow) probe.style.wrap = 'none';
    var rectangle = rectangleForFrame(object.frame);
    var measurement = layouts.measureTextObject(probe);
    var paddingX = probe.style.paddingX * WIDTH;
    var paddingY = probe.style.paddingY * HEIGHT;
    var requiredWidth = probe.style.autoGrow
      ? measurement.textWidth + Math.max(8, paddingX * 2)
      : rectangle.width;
    var requiredHeight = measurement.textHeight + Math.max(6, paddingY * 2);
    return {
      frame: centeredFrameForSize(
        object.frame,
        Math.max(rectangle.width, requiredWidth, 24),
        Math.max(rectangle.height, requiredHeight, 12)
      ),
      style: probe.style
    };
  }

  function setTextNodeFrame(node, frame) {
    var rectangle = rectangleForFrame(frame);
    node.position({
      x: rectangle.x + rectangle.width / 2,
      y: rectangle.y + rectangle.height / 2
    });
    node.width(rectangle.width);
    node.height(rectangle.height);
    node.offset({ x: rectangle.width / 2, y: rectangle.height / 2 });
  }

  function nodeFontStyle(style) {
    var parts = [];
    if (style.fontWeight !== 400) parts.push(String(style.fontWeight));
    if (style.fontStyle === 'italic') parts.push('italic');
    return parts.join(' ') || 'normal';
  }

  function createTextNode(object, side) {
    var rectangle = rectangleForFrame(object.frame);
    var measurement = layouts.measureTextObject(object);
    var width = rectangle.width;
    var height = rectangle.height;
    return new Konva.Text({
      id: object.id,
      x: rectangle.x + rectangle.width / 2,
      y: rectangle.y + rectangle.height / 2,
      width: width,
      height: height,
      offsetX: width / 2,
      offsetY: height / 2,
      text: measurement.lines.join('\n'),
      fill: object.placeholder ? '#5f6763' : object.style.fill,
      fontFamily: object.style.fontFamily,
      fontStyle: object.placeholder ? 'italic' : nodeFontStyle(object.style),
      fontSize: measurement.size,
      letterSpacing: (object.style.letterSpacing || 0) * HEIGHT,
      lineHeight: object.style.lineHeight,
      align: object.style.align,
      verticalAlign: 'middle',
      wrap: 'word',
      ellipsis: false,
      rotation: object.rotation,
      draggable: true,
      listening: true,
      opacity: object.placeholder && object.placeholder.state === 'dormant' ? .58 : 1,
      designObjectId: object.id,
      designSide: side,
      designType: 'text',
      designPreserveAspect: false,
      designPlaceholder: Boolean(object.placeholder)
    });
  }

  function createImageNode(object, side) {
    var image = object.asset && imageElements[object.asset.id];
    var rectangle = rectangleForFrame(object.frame);
    if (!image) {
      var placeholder = new Konva.Group({
        id: object.id,
        x: rectangle.x + rectangle.width / 2,
        y: rectangle.y + rectangle.height / 2,
        width: rectangle.width,
        height: rectangle.height,
        offsetX: rectangle.width / 2,
        offsetY: rectangle.height / 2,
        rotation: object.rotation,
        draggable: true,
        listening: true,
        designObjectId: object.id,
        designSide: side,
        designType: 'image',
        designRole: object.role,
        designPreserveAspect: object.role !== 'professional-artwork',
        designPlaceholder: true
      });
      placeholder.add(new Konva.Rect({
        width: rectangle.width,
        height: rectangle.height,
        fill: 'rgba(255,255,255,.66)',
        stroke: '#6d7672',
        strokeWidth: 2,
        dash: [10, 7],
        cornerRadius: 3
      }));
      placeholder.add(new Konva.Text({
        width: rectangle.width,
        height: rectangle.height,
        text: object.placeholder ? object.placeholder.label : 'Add image',
        fill: '#4b5551',
        fontFamily: 'Arial, sans-serif',
        fontSize: Math.min(17, Math.max(8, rectangle.width / 9), Math.max(8, rectangle.height / 3)),
        fontStyle: '600',
        align: 'center',
        verticalAlign: 'middle',
        listening: false
      }));
      return placeholder;
    }
    var contentFrame = object.style.contentFrame;
    var imageX;
    var imageY;
    var imageWidth;
    var imageHeight;
    if (contentFrame) {
      imageX = rectangle.width * contentFrame.x;
      imageY = rectangle.height * contentFrame.y;
      imageWidth = rectangle.width * contentFrame.width;
      imageHeight = rectangle.height * contentFrame.height;
    } else {
      var padding = Math.min(10, rectangle.height * object.style.padding);
      var availableWidth = rectangle.width - padding * 2;
      var availableHeight = rectangle.height - padding * 2;
      var naturalWidth = image.naturalWidth || image.width;
      var naturalHeight = image.naturalHeight || image.height;
      var imageScale = object.style.fit === 'cover'
        ? Math.max(availableWidth / naturalWidth, availableHeight / naturalHeight)
        : Math.min(availableWidth / naturalWidth, availableHeight / naturalHeight);
      imageWidth = object.style.fit === 'fill' ? availableWidth : naturalWidth * imageScale;
      imageHeight = object.style.fit === 'fill' ? availableHeight : naturalHeight * imageScale;
      imageX = (rectangle.width - imageWidth) / 2;
      if (object.style.align === 'left') imageX = padding;
      if (object.style.align === 'right') imageX = rectangle.width - padding - imageWidth;
      imageY = (rectangle.height - imageHeight) / 2;
    }
    var group = new Konva.Group({
      id: object.id,
      x: rectangle.x + rectangle.width / 2,
      y: rectangle.y + rectangle.height / 2,
      width: rectangle.width,
      height: rectangle.height,
      offsetX: rectangle.width / 2,
      offsetY: rectangle.height / 2,
      opacity: object.style.opacity,
      rotation: object.rotation,
      draggable: true,
      listening: true,
      clipX: 0,
      clipY: 0,
      clipWidth: rectangle.width,
      clipHeight: rectangle.height,
      designObjectId: object.id,
      designSide: side,
      designType: 'image',
      designRole: object.role,
      designPreserveAspect: object.role !== 'professional-artwork' && object.style.fit !== 'fill'
    });
    group.add(new Konva.Rect({
      width: rectangle.width,
      height: rectangle.height,
      fill: 'rgba(0, 0, 0, 0)',
      listening: false,
      name: 'design-frame'
    }));
    group.add(new Konva.Image({
      x: imageX,
      y: imageY,
      width: imageWidth,
      height: imageHeight,
      image: image,
      listening: true,
      name: 'design-image-content'
    }));
    return group;
  }

  function imageContentFrame(node) {
    if (!node || node.getAttr('designType') !== 'image' || !node.width() || !node.height()) return null;
    var image = node.findOne('.design-image-content');
    if (!image) return null;
    return {
      x: image.x() / node.width(),
      y: image.y() / node.height(),
      width: image.width() / node.width(),
      height: image.height() / node.height()
    };
  }

  function keepNodeRecoverable(node) {
    var box = node.getClientRect({ relativeTo: node.getParent(), skipShadow: true, skipStroke: true });
    var visibleGrip = 12;
    var dx = 0;
    var dy = 0;
    if (box.x + box.width < visibleGrip) dx = visibleGrip - box.x - box.width;
    else if (box.x > WIDTH - visibleGrip) dx = WIDTH - visibleGrip - box.x;
    if (box.y + box.height < visibleGrip) dy = visibleGrip - box.y - box.height;
    else if (box.y > HEIGHT - visibleGrip) dy = HEIGHT - visibleGrip - box.y;
    if (dx || dy) node.position({ x: node.x() + dx, y: node.y() + dy });
    return 1;
  }

  function snapNode(node) {
    var centers = [
      SAFE.x + SAFE.width * .25,
      SAFE.x + SAFE.width * .5,
      SAFE.x + SAFE.width * .75
    ];
    for (var index = 0; index < centers.length; index += 1) {
      if (Math.abs(node.x() - centers[index]) <= SNAP_DISTANCE) {
        node.x(centers[index]);
        break;
      }
    }
    var verticalCenter = SAFE.y + SAFE.height * .5;
    if (Math.abs(node.y() - verticalCenter) <= 6) node.y(verticalCenter);
  }

  function normalizeTransformedNode(node, activeAnchor) {
    var scaleX = Math.abs(node.scaleX());
    var scaleY = Math.abs(node.scaleY());
    var horizontalResize = activeAnchor === 'middle-left' || activeAnchor === 'middle-right';
    var verticalResize = activeAnchor === 'top-center' || activeAnchor === 'bottom-center';
    if (!verticalResize) node.width(Math.max(24, node.width() * scaleX));
    if (!horizontalResize) node.height(Math.max(12, node.height() * scaleY));
    node.scale({ x: 1, y: 1 });
    node.offsetX(node.width() / 2);
    node.offsetY(node.height() / 2);
    node.rotation(clamp(node.rotation(), -ROTATION_LIMIT, ROTATION_LIMIT));
    return horizontalResize || verticalResize ? 1 : scaleY;
  }

  function frameFromNode(node, includeScale) {
    var scaleX = includeScale ? Math.abs(node.scaleX()) : 1;
    var scaleY = includeScale ? Math.abs(node.scaleY()) : 1;
    var width = node.width() * scaleX;
    var height = node.height() * scaleY;
    return {
      x: (node.x() - width / 2) / WIDTH,
      y: (node.y() - height / 2) / HEIGHT,
      width: Math.max(width / WIDTH, 1 / WIDTH),
      height: Math.max(height / HEIGHT, 1 / HEIGHT)
    };
  }

  function stageNode(objectId) {
    var record = selectedSide && stages[selectedSide];
    return record && record.layer.findOne('#' + objectId);
  }

  function updateHistoryButtons() {
    undoButton.disabled = historyIndex <= 0;
    redoButton.disabled = historyIndex < 0 || historyIndex >= history.length - 1;
    configuratorRoot.setAttribute('data-configurator-editor-history-size', String(history.length));
    configuratorRoot.setAttribute('data-configurator-editor-history-index', String(historyIndex));
  }

  function resetHistory(document) {
    history = document ? [JSON.stringify(document)] : [];
    historyIndex = history.length ? 0 : -1;
    updateHistoryButtons();
  }

  function recordHistory(document) {
    var snapshot = JSON.stringify(document);
    if (history[historyIndex] === snapshot) return;
    history = history.slice(0, historyIndex + 1);
    history.push(snapshot);
    if (history.length > HISTORY_LIMIT) history.shift();
    historyIndex = history.length - 1;
    updateHistoryButtons();
  }

  function commitDocument(document, actionType, options) {
    if (previewTimer) window.clearTimeout(previewTimer);
    previewTimer = null;
    if (documents.getKnownPrintColors(document).length > 2) {
      status.textContent = 'This design can use up to two detectable print colors. Replace an existing color before adding another.';
      projectCurrentDocument({
        resetHistory: false,
        selectIds: selectedIds.slice(),
        selectSide: selectedSide,
        message: 'This design can use up to two detectable print colors. Replace an existing color before adding another.'
      });
      return false;
    }
    internalMutation = true;
    var committed = app.updateDesignDocument(document, { type: actionType });
    internalMutation = false;
    if (!committed) {
      status.textContent = 'That change could not be applied safely.';
      projectCurrentDocument({ resetHistory: false });
      return false;
    }
    if (!options || options.history !== false) recordHistory(document);
    status.textContent = options && options.message ? options.message : 'Design saved for this session.';
    return true;
  }

  function scheduleDocumentPreview(document) {
    if (!artworkRenderer || !artworkRenderer.previewDocument || !document) return;
    if (previewTimer) window.clearTimeout(previewTimer);
    previewTimer = window.setTimeout(function () {
      previewTimer = null;
      if (active && !destroyed) artworkRenderer.previewDocument(document);
    }, 45);
  }

  function previewNodesGeometry(nodes) {
    var document = clone(documentSnapshot());
    if (!document) return;
    nodes.forEach(function (node) {
      var location = locateObject(document, node.id());
      if (!location) return;
      location.object.frame = frameFromNode(node, true);
      location.object.rotation = Math.round(node.rotation() * 10) / 10;
      var record = stages[node.getAttr('designSide')];
      var anchor = record && record.transformAnchor;
      var axisResize = ['middle-left', 'middle-right', 'top-center', 'bottom-center'].indexOf(anchor) !== -1;
      if (location.object.type === 'text' && !axisResize && Math.abs(node.scaleY()) !== 1) {
        location.object.style.fontSize = clamp(location.object.style.fontSize * Math.abs(node.scaleY()), 4 / HEIGHT, 10);
      }
      if (
        location.object.type === 'image' &&
        ['middle-left', 'middle-right', 'top-center', 'bottom-center'].indexOf(anchor) !== -1
      ) {
        var contentFrame = imageContentFrame(node);
        if (contentFrame) location.object.style.contentFrame = contentFrame;
      }
    });
    scheduleDocumentPreview(document);
  }

  function patchObject(objectId, patch, actionType, options) {
    var document = clone(documentSnapshot());
    var location = locateObject(document, objectId);
    if (!location) return false;
    if (patch.frame) location.object.frame = clone(patch.frame);
    if (typeof patch.rotation === 'number') location.object.rotation = patch.rotation;
    if (patch.style) location.object.style = Object.assign({}, location.object.style, clone(patch.style));
    if (patch.literalValue !== undefined) {
      if (location.object.type !== 'text' || location.object.content.kind !== 'literal') return false;
      location.object.content.value = String(patch.literalValue).slice(0, 2000);
    }
    return commitDocument(document, actionType, options);
  }

  function commitNodesGeometry(nodes, actionType, resizeScales) {
    var document = clone(documentSnapshot());
    if (!document || !nodes.length) return false;
    nodes.forEach(function (node) {
      var location = locateObject(document, node.id());
      if (!location) return;
      location.object.frame = frameFromNode(node);
      location.object.rotation = Math.round(node.rotation() * 10) / 10;
      var resizeScale = resizeScales && resizeScales[node.id()];
      if (location.object.type === 'text' && resizeScale && resizeScale !== 1) {
        location.object.style.fontSize = clamp(location.object.style.fontSize * resizeScale, 4 / HEIGHT, 10);
      }
      if (location.object.type === 'text' && node.getAttr('designTextAutoGrowDisabled')) {
        location.object.style.autoGrow = false;
        node.setAttr('designTextAutoGrowDisabled', false);
      }
      if (location.object.type === 'image' && node.getAttr('designAxisResized')) {
        var contentFrame = node.getAttr('designImageContentFrame');
        if (contentFrame) location.object.style.contentFrame = clone(contentFrame);
      }
    });
    var committed = commitDocument(document, actionType);
    if (committed) updateSelectionControls();
    return committed;
  }

  function clearTransformers() {
    ['front', 'back'].forEach(function (side) {
      if (stages[side] && stages[side].transformer) {
        stages[side].transformer.nodes([]);
        stages[side].layer.batchDraw();
      }
    });
  }

  function setActiveSide(side) {
    if (side !== 'front' && side !== 'back') return;
    activeSide = side;
    ['front', 'back'].forEach(function (sideId) {
      sideElements[sideId].element.setAttribute('data-active', sideId === side ? 'true' : 'false');
      sideElements[sideId].element.removeAttribute('aria-hidden');
      sideElements[sideId].element.removeAttribute('inert');
    });
    configuratorRoot.setAttribute('data-configurator-editor-active-side', side);
    if (activeSideLabel) activeSideLabel.textContent = side.charAt(0).toUpperCase() + side.slice(1);
    var currentDocument = documentSnapshot();
    if (currentDocument && backgroundInput) backgroundInput.value = currentDocument.sides[side].background.fill;
    if (productStage) productStage.setView(side);
    Array.prototype.forEach.call(viewButtons, function (button) {
      button.setAttribute('aria-pressed', button.getAttribute('data-configurator-editor-view') === side ? 'true' : 'false');
    });
    renderObjectList();
  }

  function configureTransformer(transformer, nodes) {
    var singleText = nodes.length === 1 && nodes[0].getAttr('designType') === 'text';
    var singleImage = nodes.length === 1 && nodes[0].getAttr('designType') === 'image';
    transformer.keepRatio(true);
    transformer.enabledAnchors(singleImage
      ? ['top-left', 'top-center', 'top-right', 'middle-left', 'middle-right', 'bottom-left', 'bottom-center', 'bottom-right']
      : singleText
        ? ['top-left', 'top-center', 'top-right', 'middle-left', 'middle-right', 'bottom-left', 'bottom-center', 'bottom-right']
        : ['top-left', 'top-right', 'bottom-left', 'bottom-right']);
  }

  function selectObject(side, objectId, options) {
    var record = stages[side];
    var node = record && record.layer.findOne('#' + objectId);
    if (!node) return false;
    var additive = options && options.additive && selectedSide === side;
    if (additive && selectedIds.indexOf(objectId) !== -1) {
      selectedIds = selectedIds.filter(function (id) { return id !== objectId; });
    } else if (additive) {
      selectedIds.push(objectId);
    } else {
      selectedIds = [objectId];
    }
    if (!selectedIds.length) {
      clearSelection();
      return true;
    }
    selectedId = selectedIds[selectedIds.length - 1];
    selectedSide = side;
    setActiveSide(side);
    clearTransformers();
    var nodes = selectedIds.map(function (id) { return record.layer.findOne('#' + id); }).filter(Boolean);
    selectedIds = nodes.map(function (selectedNode) { return selectedNode.id(); });
    selectedId = selectedIds[selectedIds.length - 1];
    record.transformer.nodes(nodes);
    configureTransformer(record.transformer, nodes);
    record.transformer.moveToTop();
    record.layer.batchDraw();
    sideElements[side].host.classList.add('is-object-selected');
    updateSelectionControls();
    configuratorRoot.setAttribute('data-configurator-editor-selected-object', objectId);
    configuratorRoot.setAttribute('data-configurator-editor-selection-count', String(selectedIds.length));
    renderObjectList();
    if (!options || options.focus !== false) sideElements[side].viewport.focus({ preventScroll: true });
    return true;
  }

  function clearSelection() {
    selectedId = null;
    selectedIds = [];
    selectedSide = null;
    clearTransformers();
    ['front', 'back'].forEach(function (side) {
      sideElements[side].host.classList.remove('is-object-selected');
    });
    configuratorRoot.removeAttribute('data-configurator-editor-selected-object');
    configuratorRoot.setAttribute('data-configurator-editor-selection-count', '0');
    updateSelectionControls();
    renderObjectList();
  }

  function objectLabel(object, index) {
    var resolved = resolvedObject(object.id);
    if (object.type === 'image') {
      if (object.assetRef && object.assetRef.kind === 'semantic') return 'Logo';
      var location = locateObject(documentSnapshot(), object.id);
      var noun = object.role === 'professional-artwork' ? 'Artwork' : 'Image';
      var peers = location ? location.side && documentSnapshot().sides[location.side].objects.filter(function (candidate) {
        return candidate.type === 'image' && Boolean(resolvedObject(candidate.id)) &&
          (candidate.role === 'professional-artwork') === (object.role === 'professional-artwork');
      }) : [];
      var ordinal = peers.findIndex(function (candidate) { return candidate.id === object.id; }) + 1;
      return peers.length > 1 ? noun + ' ' + Math.max(1, ordinal) : noun;
    }
    var semanticLabels = {
      restaurantName: 'Restaurant name',
      'restaurantInfo.address': 'Address',
      'restaurantInfo.phone': 'Phone',
      'restaurantInfo.contact': 'Website or contact',
      message: 'Message',
      additionalText: 'Additional text'
    };
    var value = object.content.kind === 'literal'
      ? object.content.value
      : resolved && resolved.sourceText
        ? resolved.sourceText
        : semanticLabels[object.content.reference] || 'Text';
    value = String(value || 'Text').replace(/\s+/g, ' ').trim();
    return value.length > 32 ? value.slice(0, 31) + '…' : value;
  }

  function renderObjectList() {
    if (!objectList) return;
    objectList.textContent = '';
    var document = documentSnapshot();
    if (!document || !document.sides || !document.sides[activeSide]) return;
    document.sides[activeSide].objects.filter(function (object) {
      return Boolean(resolvedObject(object.id));
    }).forEach(function (object, index) {
      var button = documentRootButton(object, index);
      objectList.appendChild(button);
    });
  }

  function documentRootButton(object, index) {
    var button = window.document.createElement('button');
    button.type = 'button';
    button.setAttribute('data-configurator-editor-object-id', object.id);
    button.setAttribute('aria-pressed', selectedIds.indexOf(object.id) !== -1 ? 'true' : 'false');
    var icon = window.document.createElement('i');
    icon.textContent = object.type === 'image' ? '▧' : 'T';
    icon.setAttribute('aria-hidden', 'true');
    var label = window.document.createElement('span');
    label.textContent = objectLabel(object, index);
    button.appendChild(icon);
    button.appendChild(label);
    var handle = window.document.createElement('small');
    handle.textContent = '⋮⋮';
    handle.setAttribute('aria-hidden', 'true');
    button.appendChild(handle);
    return button;
  }

  function startInlineTextEdit(node, side, record) {
    var object = documentObject(node.id());
    if (
      inlineTextEditor || !object || object.type !== 'text' ||
      (object.content.kind !== 'literal' && !semanticReferenceIsDirectlyEditable(object.content.reference))
    ) return;

    var stageBox = record.stage.container().getBoundingClientRect();
    var nodeBox = node.getClientRect({ relativeTo: record.stage, skipShadow: true, skipStroke: true });
    var scale = record.stage.scaleX() || 1;
    var originalText = node.text();
    var input = document.createElement('input');
    input.type = 'text';
    input.className = 'custom-chopstick-configurator-editor__inline-text-editor';
    input.value = textInput.value;
    input.maxLength = textInput.maxLength || 2000;
    input.setAttribute('aria-label', 'Edit selected sleeve text');
    input.style.left = Math.round(window.scrollX + stageBox.left + nodeBox.x * scale) + 'px';
    input.style.top = Math.round(window.scrollY + stageBox.top + nodeBox.y * scale) + 'px';
    input.style.width = Math.max(90, Math.round(nodeBox.width * scale)) + 'px';
    input.style.height = Math.max(34, Math.round(nodeBox.height * scale)) + 'px';
    input.style.fontFamily = object.style.fontFamily;
    input.style.fontSize = Math.max(14, object.style.fontSize * HEIGHT * scale) + 'px';
    input.style.fontWeight = object.style.fontWeight >= 600 ? '700' : '400';
    input.style.fontStyle = object.style.fontStyle;
    input.style.color = object.style.fill;
    document.body.appendChild(input);
    inlineTextEditor = input;
    node.hide();
    record.transformer.hide();
    record.layer.draw();
    input.focus();
    input.select();

    var finished = false;
    function finish(cancel) {
      if (finished) return;
      finished = true;
      inlineTextEditor = null;
      input.remove();
      node.show();
      record.transformer.show();
      if (cancel) {
        node.text(originalText);
        record.layer.draw();
        updateSelectionControls();
        if (previewTimer) window.clearTimeout(previewTimer);
        previewTimer = null;
        if (artworkRenderer && artworkRenderer.restore) artworkRenderer.restore();
        return;
      }
      textInput.value = input.value || ' ';
      commitTextControl('content', 'editor:inline-text-updated');
    }

    input.addEventListener('input', function () {
      node.text(input.value || ' ');
      textInput.value = input.value || ' ';
      previewTextControl();
    });
    input.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        finish(false);
      } else if (event.key === 'Escape') {
        event.preventDefault();
        finish(true);
      }
    });
    input.addEventListener('blur', function () { finish(false); });
  }

  function bindNode(node, side, record) {
    node.on('mouseenter', function () { record.stage.container().style.cursor = 'move'; });
    node.on('mouseleave', function () { record.stage.container().style.cursor = 'default'; });
    node.on('click tap', function (event) {
      event.cancelBubble = true;
      var sourceEvent = event.evt || {};
      selectObject(side, node.id(), { additive: Boolean(sourceEvent.shiftKey || sourceEvent.metaKey || sourceEvent.ctrlKey) });
    });
    node.on('dblclick dbltap', function (event) {
      event.cancelBubble = true;
      if (!selectObject(side, node.id(), { focus: false })) return;
      var object = documentObject(node.id());
      if (
        object &&
        object.type === 'text' &&
        (object.content.kind === 'literal' || semanticReferenceIsDirectlyEditable(object.content.reference))
      ) {
        startInlineTextEdit(node, side, record);
      }
    });
    node.on('dragstart', function () {
      if (selectedSide !== side || selectedIds.indexOf(node.id()) === -1) selectObject(side, node.id(), { focus: false });
      record.dragState = {
        nodeId: node.id(),
        x: node.x(),
        y: node.y(),
        peers: selectedIds.filter(function (id) { return id !== node.id(); }).map(function (id) {
          var peer = record.layer.findOne('#' + id);
          return peer && { node: peer, x: peer.x(), y: peer.y() };
        }).filter(Boolean)
      };
    });
    node.on('dragmove', function () {
      snapNode(node);
      if (record.dragState && record.dragState.nodeId === node.id()) {
        var dx = node.x() - record.dragState.x;
        var dy = node.y() - record.dragState.y;
        record.dragState.peers.forEach(function (peer) {
          peer.node.position({ x: peer.x + dx, y: peer.y + dy });
        });
      }
      record.layer.batchDraw();
      previewNodesGeometry(selectedIds.map(function (id) { return record.layer.findOne('#' + id); }).filter(Boolean));
    });
    node.on('dragend', function () {
      var nodes = selectedIds.map(function (id) { return record.layer.findOne('#' + id); }).filter(Boolean);
      nodes.forEach(keepNodeRecoverable);
      record.dragState = null;
      commitNodesGeometry(nodes, 'editor:objects-moved');
    });
    node.on('transform', function () {
      node.rotation(clamp(node.rotation(), -ROTATION_LIMIT, ROTATION_LIMIT));
      if (
        node.getAttr('designType') === 'text' &&
        (record.transformAnchor === 'middle-left' || record.transformAnchor === 'middle-right') &&
        !record.normalizingTextWidth
      ) {
        record.normalizingTextWidth = true;
        var nextWidth = Math.max(24, node.width() * Math.abs(node.scaleX()));
        node.width(nextWidth);
        node.scaleX(1);
        node.offsetX(nextWidth / 2);
        record.transformer.forceUpdate();
        record.normalizingTextWidth = false;
      }
      if (
        node.getAttr('designType') === 'text' &&
        (record.transformAnchor === 'top-center' || record.transformAnchor === 'bottom-center') &&
        !record.normalizingTextHeight
      ) {
        record.normalizingTextHeight = true;
        var nextHeight = Math.max(12, node.height() * Math.abs(node.scaleY()));
        node.height(nextHeight);
        node.scaleY(1);
        node.offsetY(nextHeight / 2);
        record.transformer.forceUpdate();
        record.normalizingTextHeight = false;
      }
      record.layer.batchDraw();
      previewNodesGeometry(record.transformer.nodes());
    });
  }

  function addGuides(layer) {
    layer.add(new Konva.Rect({
      x: SAFE.x,
      y: SAFE.y,
      width: SAFE.width,
      height: SAFE.height,
      stroke: 'rgba(35, 50, 46, .42)',
      strokeWidth: 1,
      dash: [6, 5],
      listening: false
    }));
  }

  function buildSide(side) {
    var sideElement = sideElements[side];
    var record = stages[side];
    if (!record) {
      sideElement.host.textContent = '';
      var stage = new Konva.Stage({ container: sideElement.host, width: WIDTH, height: HEIGHT });
      var layer = new Konva.Layer();
      stage.add(layer);
      record = { stage: stage, layer: layer, transformer: null };
      stage.on('click tap', function (event) {
        var transformer = record.transformer;
        if (transformer && (event.target === transformer || event.target.getParent() === transformer)) return;
        if (!event.target.getAttr('designObjectId')) clearSelection();
        setActiveSide(side);
      });
      stages[side] = record;
    }
    record.layer.destroyChildren();
    record.transformer = null;
    var sideDocument = resolvedDocument.sides[side];

    record.layer.add(new Konva.Rect({
      x: 0,
      y: 0,
      width: WIDTH,
      height: HEIGHT,
      fill: sideDocument.background.fill,
      listening: true,
      id: 'editor-background-' + side,
      name: 'editor-background'
    }));
    sideDocument.objects.forEach(function (object) {
      var node = object.type === 'image' ? createImageNode(object, side) : createTextNode(object, side);
      if (!node) return;
      bindNode(node, side, record);
      record.layer.add(node);
    });
    addGuides(record.layer);

    var transformer = new Konva.Transformer({
      rotateEnabled: true,
      rotationSnaps: [-30, -15, 0, 15, 30],
      rotationSnapTolerance: 5,
      keepRatio: true,
      flipEnabled: false,
      borderStroke: '#e96632',
      borderStrokeWidth: 1,
      anchorFill: '#ffffff',
      anchorStroke: '#e96632',
      anchorStrokeWidth: 2,
      anchorSize: 12,
      anchorCornerRadius: 6,
      rotateAnchorOffset: 16,
      padding: 0,
      enabledAnchors: ['top-left', 'top-right', 'bottom-left', 'bottom-right'],
      boundBoxFunc: function (oldBox, newBox) {
        var stageScale = record.stage.scaleX() || 1;
        if (
          Math.abs(newBox.width) < 24 * stageScale ||
          Math.abs(newBox.height) < 12 * stageScale
        ) return oldBox;
        return newBox;
      }
    });
    record.transformer = transformer;
    transformer.on('transformstart', function () {
      record.transformAnchor = transformer.getActiveAnchor();
    });
    transformer.on('transformend', function () {
      var nodes = transformer.nodes();
      var resizeScales = {};
      nodes.forEach(function (node) {
        var imageAxisResized = node.getAttr('designType') === 'image' &&
          ['middle-left', 'middle-right', 'top-center', 'bottom-center'].indexOf(record.transformAnchor) !== -1;
        node.setAttr('designAxisResized', imageAxisResized);
        node.setAttr('designImageContentFrame', imageAxisResized ? imageContentFrame(node) : null);
        if (
          node.getAttr('designType') === 'text' &&
          ['middle-left', 'middle-right', 'top-center', 'bottom-center'].indexOf(record.transformAnchor) !== -1
        ) node.setAttr('designTextAutoGrowDisabled', true);
        resizeScales[node.id()] = normalizeTransformedNode(node, record.transformAnchor) * keepNodeRecoverable(node);
      });
      record.transformAnchor = null;
      if (commitNodesGeometry(nodes, 'editor:objects-transformed', resizeScales)) {
        projectCurrentDocument({ resetHistory: false, selectIds: selectedIds.slice(), selectSide: side });
      }
    });
    record.layer.add(transformer);
    fitStage(side);
    record.layer.draw();
  }

  function fitStage(side) {
    var record = stages[side];
    var sideElement = sideElements[side];
    if (!record || !sideElement.shell.clientWidth) return;
    var shellStyle = window.getComputedStyle(sideElement.shell);
    var horizontalPadding =
      (parseFloat(shellStyle.paddingLeft) || 0) +
      (parseFloat(shellStyle.paddingRight) || 0);
    var availableWidth = sideElement.shell.clientWidth - horizontalPadding;
    var scale = Math.max(.28, Math.min(1, availableWidth / WIDTH));
    var displayWidth = Math.round(WIDTH * scale);
    var displayHeight = Math.round(HEIGHT * scale);
    record.stage.width(displayWidth);
    record.stage.height(displayHeight);
    record.stage.scale({ x: scale, y: scale });
    sideElement.host.style.width = displayWidth + 'px';
    sideElement.host.style.height = displayHeight + 'px';
    var shellBox = sideElement.shell.getBoundingClientRect();
    var sleeveBox = sideElement.host.getBoundingClientRect();
    var sleeveLeft = sleeveBox.left - shellBox.left;
    var sleeveTop = sleeveBox.top - shellBox.top;
    var sleeveBottom = sleeveBox.bottom - shellBox.top;
    sideElement.shell.style.setProperty('--editor-sleeve-left', sleeveLeft + 'px');
    sideElement.shell.style.setProperty('--editor-sleeve-top', sleeveTop + 'px');
    sideElement.shell.style.setProperty('--editor-sleeve-width', sleeveBox.width + 'px');
    sideElement.shell.style.setProperty('--editor-sleeve-height', sleeveBox.height + 'px');
    sideElement.shell.style.setProperty('--editor-sleeve-bottom', sleeveBottom + 'px');
    sideElement.shell.style.setProperty('--csd-sleeve-left', sleeveLeft + 'px');
    sideElement.shell.style.setProperty('--csd-sleeve-width', sleeveBox.width + 'px');
    if (record.transformer) record.transformer.forceUpdate();
    record.layer.batchDraw();
  }

  function loadImages(resolved) {
    var assets = {};
    resolved.sides.front.objects.concat(resolved.sides.back.objects).forEach(function (object) {
      if (object.type === 'image' && object.asset) assets[object.asset.id] = object.asset;
    });
    var nextElements = {};
    var nextUrls = [];
    var nextUrlByAssetId = {};
    var createdUrls = [];
    return Promise.all(Object.keys(assets).map(function (assetId) {
      if (assets[assetId].element) {
        nextElements[assetId] = assets[assetId].element;
        return Promise.resolve();
      }
      if (imageElements[assetId] && imageUrlByAssetId[assetId]) {
        nextElements[assetId] = imageElements[assetId];
        nextUrls.push(imageUrlByAssetId[assetId]);
        nextUrlByAssetId[assetId] = imageUrlByAssetId[assetId];
        return Promise.resolve();
      }
      return new Promise(function (resolve, reject) {
        var url = URL.createObjectURL(assets[assetId].blob);
        nextUrls.push(url);
        createdUrls.push(url);
        nextUrlByAssetId[assetId] = url;
        var image = new Image();
        image.onload = function () {
          nextElements[assetId] = image;
          resolve();
        };
        image.onerror = reject;
        image.src = url;
      });
    })).then(function () {
      return { elements: nextElements, urls: nextUrls, urlsByAssetId: nextUrlByAssetId, createdUrls: createdUrls };
    }).catch(function (error) {
      createdUrls.forEach(function (url) { URL.revokeObjectURL(url); });
      throw error;
    });
  }

  function resolveForEditor(snapshot) {
    var configuration = clone(snapshot.configuration);
    var document = configuration.design.document;
    if (!document || !documents.validateDocument(document, configuration)) {
      return Promise.reject(new Error('Choose a valid design before editing.'));
    }
    return app.getLogoAsset().then(function (logoRecord) {
      var logoActive = enabledModules(configuration).indexOf('logo') !== -1;
      var logoMissing = logoActive && (!logoRecord || !logoRecord.blob);
      var imageAssetIds = [];
      allObjects(document).forEach(function (object) {
        if (
          object.type === 'image' && object.assetRef.kind === 'design' &&
          imageAssetIds.indexOf(object.assetRef.assetId) === -1
        ) imageAssetIds.push(object.assetRef.assetId);
      });
      return Promise.all([Promise.all(imageAssetIds.map(function (assetId) {
        return assetStore.get(assetId).then(function (record) { return { id: assetId, record: record }; });
      })), professionalTemplates.loadForDocument(document)]).then(function (assetResults) {
        var entries = assetResults[0];
        var templateAssets = assetResults[1];
        var imageAssets = {};
        entries.forEach(function (entry) { if (entry.record) imageAssets[entry.id] = entry.record; });
        return {
          resolved: documents.resolveDocument(
            document,
            configuration,
            { logo: logoMissing ? null : logoRecord, images: imageAssets, templates: templateAssets },
            { includePlaceholders: true, includeTextPlaceholders: false }
          ),
          logoMissing: logoMissing,
          missingImageCount: imageAssetIds.length - Object.keys(imageAssets).length
        };
      });
    });
  }

  function projectCurrentDocument(options) {
    if (!active || destroyed) return Promise.resolve(false);
    projectionToken += 1;
    var token = projectionToken;
    var snapshot = app.getState();
    var selectionIds = options && options.selectIds
      ? options.selectIds.slice()
      : options && options.selectId
        ? [options.selectId]
        : selectedIds.slice();
    var selectionSide = options && options.selectSide ? options.selectSide : selectedSide;
    var firstProjection = !stages.front || !stages.back;
    if (firstProjection) {
      status.textContent = 'Preparing your editable design…';
      configuratorRoot.setAttribute('data-configurator-editor-ready', 'false');
    }
    return resolveForEditor(snapshot).then(function (projection) {
      if (!active || destroyed || token !== projectionToken) return false;
      return loadImages(projection.resolved).then(function (loadedImages) {
        if (!active || destroyed || token !== projectionToken) {
          loadedImages.createdUrls.forEach(function (url) { URL.revokeObjectURL(url); });
          return false;
        }
        Object.keys(imageUrlByAssetId).forEach(function (assetId) {
          if (loadedImages.urlsByAssetId[assetId] !== imageUrlByAssetId[assetId]) {
            URL.revokeObjectURL(imageUrlByAssetId[assetId]);
          }
        });
        imageElements = loadedImages.elements;
        imageUrls = loadedImages.urls;
        imageUrlByAssetId = loadedImages.urlsByAssetId;
        resolvedDocument = projection.resolved;
        buildSide('front');
        buildSide('back');
        setActiveSide(activeSide);
        configuratorRoot.setAttribute('data-configurator-editor-stage-count', '2');
        configuratorRoot.setAttribute('data-configurator-editor-ready', 'true');
        status.textContent = options && options.message
          ? options.message
          : projection.logoMissing
            ? 'Your logo needs to be added again. The rest of the design is still editable.'
            : projection.missingImageCount
              ? 'One or more added images are unavailable. Select a placeholder to replace it.'
              : 'Select an object to begin editing.';
        if (options && options.resetHistory) resetHistory(snapshot.configuration.design.document);
        if (selectionIds.length && selectionSide) {
          var restoredSelection = false;
          selectionIds.forEach(function (selectionId, index) {
            restoredSelection = selectObject(selectionSide, selectionId, { focus: false, additive: index > 0 }) || restoredSelection;
          });
          if (!restoredSelection) clearSelection();
        } else {
          clearSelection();
        }
        return true;
      });
    }).catch(function (error) {
      if (!active || destroyed || token !== projectionToken) return false;
      status.textContent = error && error.message ? error.message : 'The editable design could not be prepared.';
      configuratorRoot.setAttribute('data-configurator-editor-ready', 'false');
      return false;
    });
  }

  function currentSelectedObjects() {
    return {
      document: documentObject(selectedId),
      resolved: resolvedObject(selectedId)
    };
  }

  function setControlValue(control, value) {
    if (control && document.activeElement !== control) control.value = value;
  }

  function ensureFontOption(fontFamily) {
    if (!fontFamily || Array.prototype.some.call(fontInput.options, function (option) { return option.value === fontFamily; })) return;
    var option = window.document.createElement('option');
    option.value = fontFamily;
    option.textContent = 'Current design font';
    fontInput.appendChild(option);
  }

  function updateSelectionControls() {
    var selected = currentSelectedObjects();
    var object = selected.document;
    var multiple = selectedIds.length > 1;
    selectionPanel.hidden = !object && !multiple;
    defaultTools.hidden = Boolean(object) || multiple;
    emptySelection.hidden = Boolean(object) && !multiple;
    emptySelection.textContent = multiple
      ? selectedIds.length + ' elements selected. Drag, resize, position, or delete them together.'
      : 'Select text or artwork to see its controls.';
    textControls.hidden = !object || multiple || object.type !== 'text';
    imageControls.hidden = !object || multiple || object.type !== 'image';
    if (selectedLabel) selectedLabel.textContent = multiple ? selectedIds.length + ' objects' : object ? objectLabel(object, 0) : 'object';
    renderObjectList();
    if (multiple) return;
    if (!object) return;
    if (object.type === 'text') {
      var semantic = object.content.kind === 'semantic';
      var semanticEditable = semantic && semanticReferenceIsDirectlyEditable(object.content.reference);
      textInput.readOnly = semantic && !semanticEditable;
      semanticNote.hidden = !semantic;
      if (semantic) {
        semanticNote.textContent = semanticEditable
          ? 'This content stays synced with your Details step.'
          : 'Edit this combined information in the Details step.';
      }
      if (semanticEditable) textInput.maxLength = app.getSemanticConstraint(object.content.reference);
      else textInput.maxLength = 2000;
      setControlValue(textInput, semantic ? (selected.resolved ? selected.resolved.sourceText || '' : '') : object.content.value);
      ensureFontOption(object.style.fontFamily);
      setControlValue(fontInput, object.style.fontFamily);
      setControlValue(fontSizeInput, String(Math.round(object.style.fontSize * HEIGHT)));
      setControlValue(letterSpacingInput, String(Math.round((object.style.letterSpacing || 0) * HEIGHT * 10) / 10));
      setControlValue(colorInput, object.style.fill);
      setControlValue(alignInput, object.style.align);
      setControlValue(textRotationInput, String(Math.round(object.rotation)));
      boldButton.setAttribute('aria-pressed', object.style.fontWeight >= 600 ? 'true' : 'false');
      italicButton.setAttribute('aria-pressed', object.style.fontStyle === 'italic' ? 'true' : 'false');
    } else {
      setControlValue(imageRotationInput, String(Math.round(object.rotation)));
      replaceImageButton.textContent = object.assetRef.kind === 'semantic' ? 'Replace logo' : 'Replace image';
    }
    if (deleteButton) deleteButton.hidden = !multiple && !object;
  }

  function setInspirationOpen(open) {
    if (!inspirationHelper || inspirationHelper.open === open) return;
    inspirationProgrammaticToggle = true;
    inspirationHelper.open = open;
    window.setTimeout(function () { inspirationProgrammaticToggle = false; }, 0);
  }

  function collapseInspirationForEditorInteraction() {
    if (!inspirationHelper || !inspirationHelper.open) return;
    inspirationHelper.setAttribute('data-context-collapsed', 'true');
    setInspirationOpen(false);
  }

  function handleInspirationToggle() {
    if (!inspirationHelper || inspirationProgrammaticToggle) return;
    if (inspirationHelper.open) inspirationHelper.removeAttribute('data-context-collapsed');
  }

  function handleEditorPointerDown(event) {
    if (!inspirationHelper || inspirationHelper.contains(event.target)) return;
    if (event.target.closest('[data-configurator-editor-stage-host], [data-configurator-editor-side]')) {
      collapseInspirationForEditorInteraction();
    }
  }

  function previewTextControl() {
    if (!selectedId || !selectedSide) return;
    var object = documentObject(selectedId);
    var node = stageNode(selectedId);
    if (!object || object.type !== 'text' || !node) return;
    var previewText = object.content.kind === 'literal' || semanticReferenceIsDirectlyEditable(object.content.reference)
      ? textInput.value || ' '
      : node.text();
    var previewWeight = boldButton.getAttribute('aria-pressed') === 'true'
      ? 700
      : object.style.fontWeight >= 600 ? 400 : object.style.fontWeight;
    var previewStyle = {
      fontFamily: fontInput.value,
      fontWeight: previewWeight,
      fontStyle: italicButton.getAttribute('aria-pressed') === 'true' ? 'italic' : 'normal',
      fontSize: Number(fontSizeInput.value) / HEIGHT,
      letterSpacing: Number(letterSpacingInput.value) / HEIGHT,
      fill: colorInput.value,
      align: alignInput.value,
      fit: 'fixed'
    };
    var growth = growTextFrame(object, previewText, previewStyle);
    setTextNodeFrame(node, growth.frame);
    node.text(previewText);
    node.fontFamily(fontInput.value);
    node.fontStyle((previewWeight !== 400 ? previewWeight + ' ' : '') +
      (italicButton.getAttribute('aria-pressed') === 'true' ? 'italic' : '') || 'normal');
    node.fontSize(Number(fontSizeInput.value));
    node.letterSpacing(Number(letterSpacingInput.value));
    node.fill(colorInput.value);
    node.align(alignInput.value);
    node.rotation(Number(textRotationInput.value));
    stages[selectedSide].transformer.forceUpdate();
    stages[selectedSide].layer.batchDraw();
    var previewDocument = clone(documentSnapshot());
    var previewLocation = locateObject(previewDocument, selectedId);
    if (previewLocation) {
      previewLocation.object.frame = clone(growth.frame);
      previewLocation.object.rotation = Number(textRotationInput.value);
      previewLocation.object.style = Object.assign({}, previewLocation.object.style, previewStyle);
      if (previewLocation.object.content.kind === 'literal') previewLocation.object.content.value = textInput.value || ' ';
      scheduleDocumentPreview(previewDocument);
    }
  }

  function previewImageRotation() {
    var node = selectedId && stageNode(selectedId);
    if (!node) return;
    node.rotation(Number(imageRotationInput.value));
    stages[selectedSide].transformer.forceUpdate();
    stages[selectedSide].layer.batchDraw();
    previewNodesGeometry([node]);
  }

  function commitTextControl(controlName, actionType) {
    var object = documentObject(selectedId);
    if (!object || object.type !== 'text') return;
    if (controlName === 'content' && object.content.kind === 'semantic') {
      if (!semanticReferenceIsDirectlyEditable(object.content.reference)) return;
      var semanticLimit = app.getSemanticConstraint(object.content.reference);
      if (textInput.value.length > semanticLimit) {
        status.textContent = 'Keep this content within ' + semanticLimit + ' characters.';
        projectCurrentDocument({ resetHistory: false, selectId: selectedId, selectSide: selectedSide });
        return;
      }
      var snapshot = app.getState();
      var values = clone(snapshot.configuration.content.values);
      if (object.content.reference.indexOf('restaurantInfo.') === 0) {
        values.restaurantInfo[object.content.reference.split('.')[1]] = textInput.value;
      } else {
        values[object.content.reference] = textInput.value;
      }
      internalMutation = true;
      var moduleId = documents.getModuleForObject(object);
      var enabled = enabledModules(snapshot.configuration).slice();
      if (moduleId && enabled.indexOf(moduleId) === -1) enabled.push(moduleId);
      var semanticUpdated = app.updateConfiguration({ content: { values: values, enabledTypes: enabled } });
      internalMutation = false;
      status.textContent = semanticUpdated ? 'Content updated and kept in sync with Details.' : 'That content could not be updated.';
      if (semanticUpdated) {
        var semanticDocument = clone(documentSnapshot());
        var semanticLocation = locateObject(semanticDocument, selectedId);
        if (semanticLocation) {
          var semanticGrowth = growTextFrame(semanticLocation.object, textInput.value || ' ', { fit: 'fixed' });
          semanticLocation.object.frame = semanticGrowth.frame;
          semanticLocation.object.style.fit = 'fixed';
          commitDocument(semanticDocument, actionType || 'editor:text-updated');
        }
      }
      projectCurrentDocument({ resetHistory: false, selectId: selectedId, selectSide: selectedSide });
      return;
    }
    var patch = {};
    if (controlName === 'content' && object.content.kind === 'literal') patch.literalValue = textInput.value || ' ';
    if (controlName === 'font') patch.style = { fontFamily: fontInput.value };
    if (controlName === 'size') patch.style = { fontSize: Number(fontSizeInput.value) / HEIGHT };
    if (controlName === 'letterSpacing') patch.style = { letterSpacing: Number(letterSpacingInput.value) / HEIGHT };
    if (controlName === 'color') patch.style = { fill: colorInput.value };
    if (controlName === 'align') patch.style = { align: alignInput.value };
    if (controlName === 'bold') {
      patch.style = { fontWeight: boldButton.getAttribute('aria-pressed') === 'true' ? 700 : 400 };
    }
    if (controlName === 'italic') {
      patch.style = { fontStyle: italicButton.getAttribute('aria-pressed') === 'true' ? 'italic' : 'normal' };
    }
    if (controlName === 'rotation') {
      patch.frame = frameFromNode(stageNode(selectedId));
      patch.rotation = Number(textRotationInput.value);
      if (Number(fontSizeInput.value) / HEIGHT !== object.style.fontSize) {
        patch.style = { fontSize: Number(fontSizeInput.value) / HEIGHT };
      }
    }
    if (controlName !== 'rotation') {
      var selectedResolved = resolvedObject(selectedId);
      var growthText = controlName === 'content'
        ? textInput.value || ' '
        : selectedResolved && (selectedResolved.sourceText || selectedResolved.text) || textInput.value || ' ';
      var textGrowth = growTextFrame(object, growthText, patch.style || {});
      patch.frame = textGrowth.frame;
      patch.style = Object.assign({}, patch.style || {}, { fit: 'fixed' });
    }
    if (patchObject(selectedId, patch, actionType || 'editor:text-updated')) {
      projectCurrentDocument({ resetHistory: false, selectId: selectedId, selectSide: selectedSide });
    }
  }

  function commitImageRotation() {
    if (!selectedId) return;
    var node = stageNode(selectedId);
    if (!node) return;
    if (patchObject(selectedId, {
      frame: frameFromNode(node),
      rotation: Number(imageRotationInput.value)
    }, 'editor:image-rotated')) {
      projectCurrentDocument({ resetHistory: false, selectId: selectedId, selectSide: selectedSide });
    }
  }

  function safeFrame(widthFraction, heightFraction) {
    var width = SAFE.width * widthFraction;
    var height = SAFE.height * heightFraction;
    return {
      x: (SAFE.x + (SAFE.width - width) / 2) / WIDTH,
      y: (SAFE.y + (SAFE.height - height) / 2) / HEIGHT,
      width: width / WIDTH,
      height: height / HEIGHT
    };
  }

  function collisionAwareFrame(widthPixels, heightPixels) {
    var record = stages[activeSide];
    var obstacles = [];
    if (record) {
      record.layer.find(function (node) { return Boolean(node.getAttr('designObjectId')); }).forEach(function (node) {
        obstacles.push(node.getClientRect({ relativeTo: record.layer }));
      });
    }
    var best = null;
    var stepX = Math.max(34, Math.round(widthPixels * .45));
    var stepY = Math.max(18, Math.round(heightPixels * .55));
    for (var y = SAFE.y; y <= SAFE.y + SAFE.height - heightPixels + .001; y += stepY) {
      for (var x = SAFE.x; x <= SAFE.x + SAFE.width - widthPixels + .001; x += stepX) {
        var score = obstacles.reduce(function (total, obstacle) {
          var overlapWidth = Math.max(0, Math.min(x + widthPixels, obstacle.x + obstacle.width) - Math.max(x, obstacle.x));
          var overlapHeight = Math.max(0, Math.min(y + heightPixels, obstacle.y + obstacle.height) - Math.max(y, obstacle.y));
          return total + overlapWidth * overlapHeight;
        }, 0);
        if (!best || score < best.score) best = { x: x, y: y, score: score };
        if (score === 0) break;
      }
      if (best && best.score === 0) break;
    }
    if (!best) return safeFrame(widthPixels / SAFE.width, heightPixels / SAFE.height);
    return { x: best.x / WIDTH, y: best.y / HEIGHT, width: widthPixels / WIDTH, height: heightPixels / HEIGHT };
  }

  function uniqueObjectId(prefix, document) {
    var candidate;
    do {
      objectCounter += 1;
      candidate = prefix + '-' + Date.now().toString(36) + '-' + objectCounter.toString(36);
    } while (locateObject(document, candidate));
    return candidate;
  }

  function addText() {
    var document = clone(documentSnapshot());
    if (!document) return;
    var object = {
      id: uniqueObjectId('custom-text', document),
      type: 'text',
      role: 'custom-text',
      frame: safeFrame(24 / SAFE.width, 16 / SAFE.height),
      rotation: 0,
      content: { kind: 'literal', value: 'Your text' },
      style: {
        fontFamily: 'Georgia, serif',
        fontWeight: 400,
        fontStyle: 'normal',
        fontSize: 24 / HEIGHT,
        lineHeight: 1.15,
        fill: '#000000',
        align: 'center',
        fit: 'fixed',
        autoGrow: true,
        paddingX: 6 / WIDTH,
        paddingY: 2 / HEIGHT
      }
    };
    var initialGrowth = growTextFrame(object, object.content.value);
    object.frame = collisionAwareFrame(initialGrowth.frame.width * WIDTH, initialGrowth.frame.height * HEIGHT);
    document.sides[activeSide].objects.push(object);
    if (commitDocument(document, 'editor:literal-text-added')) {
      projectCurrentDocument({ resetHistory: false, selectId: object.id, selectSide: activeSide });
    }
  }

  function createDesignImageObject(document, metadata) {
    var aspect = metadata && metadata.height ? metadata.width / metadata.height : 2.5;
    var heightPixels = SAFE.height * .66;
    var widthPixels = Math.min(SAFE.width * .28, heightPixels * clamp(aspect, .35, 6));
    return {
      id: uniqueObjectId('custom-image', document),
      type: 'image',
      role: 'custom-image',
      frame: collisionAwareFrame(widthPixels, heightPixels),
      rotation: 0,
      assetRef: { kind: 'design', assetId: metadata.assetId },
      style: { fit: 'contain', align: 'center', padding: .06, opacity: 1 }
    };
  }

  function designImageCount(document) {
    return allObjects(document).filter(function (object) {
      return object.type === 'image' && object.assetRef.kind === 'design';
    }).length;
  }

  function chooseDesignImage(objectId) {
    if (imageUploadBusy) return;
    var document = documentSnapshot();
    if (!objectId && designImageCount(document) >= assetStore.constraints.maximumDesignAssets) {
      status.textContent = 'This design already has the maximum of ' + assetStore.constraints.maximumDesignAssets + ' added images.';
      return;
    }
    pendingImageObjectId = objectId || null;
    imageInput.click();
  }

  function chooseSemanticLogo() {
    if (imageUploadBusy) return;
    pendingImageObjectId = '__semantic-logo__';
    imageInput.click();
  }

  function handleDesignImageFile(file) {
    if (!file || imageUploadBusy) return;
    imageUploadBusy = true;
    status.textContent = 'Checking your image…';
    assetStore.saveDesignImage(file).then(function (saved) {
      if (destroyed) {
        assetStore.remove(saved.metadata.assetId);
        return false;
      }
      var document = clone(documentSnapshot());
      var target = pendingImageObjectId && locateObject(document, pendingImageObjectId);
      var object;
      if (target) {
        if (target.object.type !== 'image' || target.object.assetRef.kind === 'semantic') {
          assetStore.remove(saved.metadata.assetId);
          return false;
        }
        target.object.assetRef = { kind: 'design', assetId: saved.metadata.assetId };
        object = target.object;
      } else {
        if (designImageCount(document) >= assetStore.constraints.maximumDesignAssets) {
          assetStore.remove(saved.metadata.assetId);
          status.textContent = 'This design already has the maximum number of added images.';
          return false;
        }
        object = createDesignImageObject(document, saved.metadata);
        document.sides[activeSide].objects.push(object);
      }
      if (!commitDocument(document, target ? 'editor:image-replaced' : 'editor:image-added')) {
        assetStore.remove(saved.metadata.assetId);
        return false;
      }
      createdAssetIds.push(saved.metadata.assetId);
      projectCurrentDocument({ resetHistory: false, selectId: object.id, selectSide: target ? target.side : activeSide });
      return true;
    }).catch(function (error) {
      status.textContent = error && error.message ? error.message : 'That image could not be added.';
    }).then(function () {
      imageUploadBusy = false;
      pendingImageObjectId = null;
      imageInput.value = '';
    });
  }

  function deleteSelected() {
    if (!selectedIds.length) return;
    var snapshot = app.getState();
    var document = documents.deleteObjects(snapshot.configuration.design.document, selectedIds);
    if (document && commitDocument(document, 'editor:object-deleted')) {
      clearSelection();
      projectCurrentDocument({ resetHistory: false });
    }
  }

  function restoreHistory(index, actionType) {
    if (index < 0 || index >= history.length) return;
    var document = JSON.parse(history[index]);
    internalMutation = true;
    var restored = app.updateDesignDocument(document, { type: actionType });
    internalMutation = false;
    if (!restored) {
      status.textContent = 'That history state is no longer compatible with the current content.';
      return;
    }
    historyIndex = index;
    updateHistoryButtons();
    status.textContent = actionType === 'editor:history-undo' ? 'Last design change undone.' : 'Design change restored.';
    projectCurrentDocument({ resetHistory: false });
  }

  function resetSide() {
    var before = clone(documentSnapshot());
    var snapshot = app.getState();
    var pristine = before && designRecipes.instantiate(before.provenance.sourceId, snapshot.configuration);
    if (!before || !pristine || !pristine.sides || !pristine.sides[activeSide]) {
      status.textContent = 'This print surface could not be reset.';
      return;
    }
    before.sides[activeSide] = clone(pristine.sides[activeSide]);
    if (before.deletedObjects) {
      var restoredIds = before.sides[activeSide].objects.map(function (object) { return object.id; });
      before.deletedObjects = before.deletedObjects.filter(function (entry) {
        return restoredIds.indexOf(entry.id) === -1;
      });
    }
    clearSelection();
    if (commitDocument(before, 'editor:side-reset', { message: activeSide.charAt(0).toUpperCase() + activeSide.slice(1) + ' restored to its starting design.' })) {
      projectCurrentDocument({ resetHistory: false });
    }
  }

  function nudgeSelected(key, shiftKey) {
    if (!selectedIds.length || !selectedSide) return false;
    var nodes = selectedIds.map(function (id) { return stages[selectedSide].layer.findOne('#' + id); }).filter(Boolean);
    if (!nodes.length) return false;
    var amount = shiftKey ? 5 : 1;
    var dx = key === 'ArrowLeft' ? -amount : key === 'ArrowRight' ? amount : 0;
    var dy = key === 'ArrowUp' ? -amount : key === 'ArrowDown' ? amount : 0;
    if (!dx && !dy) return false;
    nodes.forEach(function (node) {
      node.x(node.x() + dx);
      node.y(node.y() + dy);
      keepNodeRecoverable(node);
    });
    stages[selectedSide].layer.batchDraw();
    commitNodesGeometry(nodes, 'editor:objects-nudged');
    return true;
  }

  function setProductView(view) {
    if (view !== 'front' && view !== 'back') return;
    productStage.setView(view);
    Array.prototype.forEach.call(viewButtons, function (button) {
      button.setAttribute('aria-pressed', button.getAttribute('data-configurator-editor-view') === view ? 'true' : 'false');
    });
  }

  function nativeFullscreenElement() {
    return document.fullscreenElement || document.webkitFullscreenElement || null;
  }

  function applyFullscreenState(nextFullscreen, mode) {
    fullscreen = Boolean(nextFullscreen);
    fullscreenMode = fullscreen ? mode || 'fallback' : 'none';
    configuratorRoot.setAttribute('data-configurator-editor-fullscreen-active', fullscreen ? 'true' : 'false');
    configuratorRoot.setAttribute('data-configurator-editor-fullscreen-mode', fullscreenMode);
    fullscreenButton.setAttribute('aria-pressed', fullscreen ? 'true' : 'false');
    fullscreenButton.textContent = fullscreen ? 'Exit full screen' : 'Full screen';
    window.requestAnimationFrame(function () {
      productStage.render();
    });
  }

  function handleFullscreenChange() {
    var fullscreenElement = nativeFullscreenElement();
    if (fullscreenElement === previewElement) applyFullscreenState(true, 'native');
    else if (fullscreenMode === 'native') applyFullscreenState(false, 'none');
  }

  function setFullscreen(nextFullscreen) {
    var shouldEnter = Boolean(nextFullscreen);
    var fullscreenElement = nativeFullscreenElement();
    if (!shouldEnter) {
      if (fullscreenElement === previewElement) {
        var exit = document.exitFullscreen || document.webkitExitFullscreen;
        if (exit) {
          try { exit.call(document); } catch (error) { applyFullscreenState(false, 'none'); }
          return;
        }
      }
      applyFullscreenState(false, 'none');
      return;
    }
    if (fullscreenElement === previewElement) {
      applyFullscreenState(true, 'native');
      return;
    }
    var request = previewElement.requestFullscreen || previewElement.webkitRequestFullscreen;
    if (!request) {
      applyFullscreenState(true, 'fallback');
      return;
    }
    try {
      var result = request.call(previewElement);
      if (result && typeof result.then === 'function') {
        result.then(handleFullscreenChange, function () { applyFullscreenState(true, 'fallback'); });
      }
    } catch (error) {
      applyFullscreenState(true, 'fallback');
    }
  }

  function handleClick(event) {
    var target = event.target;
    if (
      !inspirationHelper || !inspirationHelper.contains(target)
    ) {
      if (target.closest(
        '[data-configurator-editor-object-id], [data-configurator-editor-view], ' +
        '[data-configurator-editor-clear-selection], [data-configurator-editor-fullscreen], ' +
        '[data-configurator-editor-add-text], [data-configurator-editor-add-image], ' +
        '[data-configurator-editor-undo], [data-configurator-editor-redo], ' +
        '[data-configurator-editor-reset], [data-configurator-editor-delete], ' +
        '[data-configurator-editor-replace-image], [data-configurator-editor-bold], ' +
        '[data-configurator-editor-italic]'
      )) collapseInspirationForEditorInteraction();
    }
    var objectButton = target.closest('[data-configurator-editor-object-id]');
    if (objectButton) {
      selectObject(activeSide, objectButton.getAttribute('data-configurator-editor-object-id'), {
        additive: Boolean(event.shiftKey || event.metaKey || event.ctrlKey)
      });
      return;
    }
    var viewButton = target.closest('[data-configurator-editor-view]');
    if (viewButton) {
      setProductView(viewButton.getAttribute('data-configurator-editor-view'));
      return;
    }
    if (target.closest('[data-configurator-editor-clear-selection]')) {
      clearSelection();
      return;
    }
    var surface = target.closest('[data-configurator-editor-side]');
    if (surface) {
      var surfaceSide = surface.getAttribute('data-configurator-editor-side');
      if (selectedSide && selectedSide !== surfaceSide) clearSelection();
      setActiveSide(surfaceSide);
    }
    if (target.closest('[data-configurator-editor-fullscreen]')) {
      setFullscreen(!fullscreen);
      return;
    }
    if (target.closest('[data-configurator-editor-inspiration]')) {
      app.goTo('layouts');
      return;
    }
    if (target.closest('[data-configurator-editor-done]')) {
      var activeElement = document.activeElement;
      if (
        activeElement &&
        editor.contains(activeElement) &&
        activeElement.matches(
          '[data-configurator-editor-text], [data-configurator-editor-font], [data-configurator-editor-font-size], ' +
          '[data-configurator-editor-letter-spacing], [data-configurator-editor-color], [data-configurator-editor-text-rotation], ' +
          '[data-configurator-editor-background], [data-configurator-editor-image-rotation]'
        )
      ) {
        activeElement.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (inlineTextEditor && inlineTextEditor.blur) {
        var pendingInlineTextEditor = inlineTextEditor;
        pendingInlineTextEditor.blur();
        if (inlineTextEditor === pendingInlineTextEditor) {
          pendingInlineTextEditor.dispatchEvent(new Event('blur'));
        }
      } else if (
        activeElement && activeElement.blur &&
        editor.contains(activeElement)
      ) {
        activeElement.blur();
      }
      app.next();
      return;
    }
    if (target.closest('[data-configurator-editor-back]')) {
      app.back();
      return;
    }
    if (target.closest('[data-configurator-editor-add-text]')) {
      addText();
      return;
    }
    if (target.closest('[data-configurator-editor-add-image]')) {
      chooseDesignImage(null);
      return;
    }
    if (target.closest('[data-configurator-editor-undo]')) {
      restoreHistory(historyIndex - 1, 'editor:history-undo');
      return;
    }
    if (target.closest('[data-configurator-editor-redo]')) {
      restoreHistory(historyIndex + 1, 'editor:history-redo');
      return;
    }
    if (target.closest('[data-configurator-editor-reset]')) {
      resetSide();
      return;
    }
    if (target.closest('[data-configurator-editor-delete]')) {
      deleteSelected();
      return;
    }
    if (target.closest('[data-configurator-editor-replace-image]')) {
      var selectedImage = documentObject(selectedId);
      if (selectedImage && selectedImage.type === 'image' && selectedImage.assetRef.kind !== 'semantic') {
        chooseDesignImage(selectedId);
      } else {
        chooseSemanticLogo();
      }
      return;
    }
    if (target.closest('[data-configurator-editor-bold]')) {
      boldButton.setAttribute('aria-pressed', boldButton.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
      previewTextControl();
      commitTextControl('bold', 'editor:text-weight-updated');
      return;
    }
    if (target.closest('[data-configurator-editor-italic]')) {
      italicButton.setAttribute('aria-pressed', italicButton.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
      previewTextControl();
      commitTextControl('italic', 'editor:text-style-updated');
    }
  }

  function handleInput(event) {
    if (event.target.closest('[data-configurator-editor-inspector], [data-configurator-editor-default-tools]')) {
      collapseInspirationForEditorInteraction();
    }
    if (event.target.matches('[data-configurator-editor-background]')) {
      var backgroundNode = stages[activeSide] && stages[activeSide].layer.findOne('#editor-background-' + activeSide);
      if (backgroundNode) {
        backgroundNode.fill(backgroundInput.value);
        stages[activeSide].layer.batchDraw();
      }
      var backgroundPreview = clone(documentSnapshot());
      if (backgroundPreview && backgroundPreview.sides[activeSide]) {
        backgroundPreview.sides[activeSide].background.fill = backgroundInput.value;
        scheduleDocumentPreview(backgroundPreview);
      }
      return;
    }
    if (event.target.matches('[data-configurator-editor-text], [data-configurator-editor-font], [data-configurator-editor-font-size], [data-configurator-editor-letter-spacing], [data-configurator-editor-color], [data-configurator-editor-text-rotation]')) {
      previewTextControl();
      return;
    }
    if (event.target.matches('[data-configurator-editor-image-rotation]')) previewImageRotation();
  }

  function handleChange(event) {
    if (event.target.closest('[data-configurator-editor-inspector], [data-configurator-editor-default-tools]')) {
      collapseInspirationForEditorInteraction();
    }
    if (event.target.matches('[data-configurator-editor-image-input]')) {
      var file = event.target.files && event.target.files[0];
      if (pendingImageObjectId === '__semantic-logo__') {
        pendingImageObjectId = null;
        imageInput.value = '';
        app.replaceLogoFile(file);
      } else {
        handleDesignImageFile(file);
      }
      return;
    }
    if (event.target.matches('[data-configurator-editor-background]')) {
      var backgroundDocument = clone(documentSnapshot());
      backgroundDocument.sides[activeSide].background.fill = backgroundInput.value;
      if (commitDocument(backgroundDocument, 'editor:background-updated')) {
        projectCurrentDocument({ resetHistory: false, selectId: selectedId, selectSide: selectedSide });
      }
      return;
    }
    var textControlNames = {
      'data-configurator-editor-text': 'content',
      'data-configurator-editor-font': 'font',
      'data-configurator-editor-font-size': 'size',
      'data-configurator-editor-letter-spacing': 'letterSpacing',
      'data-configurator-editor-color': 'color',
      'data-configurator-editor-align': 'align',
      'data-configurator-editor-text-rotation': 'rotation'
    };
    var textControlName = Object.keys(textControlNames).find(function (attribute) {
      return event.target.hasAttribute(attribute);
    });
    if (textControlName) {
      previewTextControl();
      commitTextControl(textControlNames[textControlName], 'editor:text-updated');
      return;
    }
    if (event.target.matches('[data-configurator-editor-image-rotation]')) commitImageRotation();
  }

  function handleKeydown(event) {
    var target = event.target;
    if (event.key === 'Escape' && fullscreen) {
      event.preventDefault();
      setFullscreen(false);
      return;
    }
    if (target && (/^(INPUT|TEXTAREA|SELECT)$/.test(target.tagName) || target.isContentEditable)) return;
    if ((event.metaKey || event.ctrlKey) && !event.altKey && event.key.toLowerCase() === 'z') {
      event.preventDefault();
      collapseInspirationForEditorInteraction();
      restoreHistory(historyIndex + (event.shiftKey ? 1 : -1), event.shiftKey ? 'editor:history-redo' : 'editor:history-undo');
      return;
    }
    if (!selectedIds.length) return;
    if (event.key === 'Delete' || event.key === 'Backspace') {
      event.preventDefault();
      collapseInspirationForEditorInteraction();
      deleteSelected();
      return;
    }
    if (nudgeSelected(event.key, event.shiftKey)) {
      collapseInspirationForEditorInteraction();
      event.preventDefault();
    }
  }

  function handleAppState(snapshot, action) {
    if (!active || internalMutation || destroyed) return;
    var document = snapshot.configuration.design.document;
    var currentHistoryDocument = historyIndex >= 0 ? history[historyIndex] : null;
    var documentChanged = document && JSON.stringify(document) !== currentHistoryDocument;
    if (action && action.designReconciliation === 'preserved-dormancy') resetHistory(document);
    else if (documentChanged && action && action.type.indexOf('configuration:update') === 0) resetHistory(document);
    else if (documentChanged && action && action.type.indexOf('design-document:') === 0) resetHistory(document);
    projectCurrentDocument({ resetHistory: historyIndex < 0 });
  }

  function handleCompactChange() {
    setActiveSide(activeSide);
    ['front', 'back'].forEach(fitStage);
  }

  function cleanupCreatedAssets() {
    var keep = app.getDesignAssetIds();
    createdAssetIds.forEach(function (assetId) {
      if (keep.indexOf(assetId) === -1) assetStore.remove(assetId);
    });
    createdAssetIds = [];
  }

  function setEditorPageScrolling(enabled) {
    document.documentElement.classList.toggle('configurator-editor-page-scroll', enabled);
    document.body.classList.toggle('configurator-editor-page-scroll', enabled);
    if (!enabled && window.scrollY) window.scrollTo(0, 0);
  }

  function setActive(nextActive) {
    var shouldActivate = Boolean(nextActive);
    if (destroyed || shouldActivate === active) return true;
    active = shouldActivate;
    editor.setAttribute('aria-hidden', active ? 'false' : 'true');
    setEditorPageScrolling(active);
    if (active) editor.removeAttribute('inert');
    else editor.setAttribute('inert', '');
    if (!active) {
      setFullscreen(false);
      productStage.mount(null);
      projectionToken += 1;
      destroyStages();
      history = [];
      historyIndex = -1;
      cleanupCreatedAssets();
      updateHistoryButtons();
      configuratorRoot.setAttribute('data-configurator-editor-ready', 'false');
      return true;
    }
    if (configuratorRoot.configuratorSampleBrowser) configuratorRoot.configuratorSampleBrowser.setActive(false);
    if (inspirationHelper) {
      inspirationHelper.removeAttribute('data-context-collapsed');
      setInspirationOpen(true);
    }
    productStage.mount(stageHost);
    productStage.setProductMode('sleeve');
    productStage.setView(activeSide);
    resetHistory(documentSnapshot());
    projectCurrentDocument({ resetHistory: false });
    if (editorTitle) editorTitle.focus({ preventScroll: true });
    return true;
  }

  function destroy() {
    if (destroyed) return;
    destroyed = true;
    active = false;
    if (previewTimer) window.clearTimeout(previewTimer);
    previewTimer = null;
    if (inlineTextEditor) inlineTextEditor.remove();
    inlineTextEditor = null;
    setFullscreen(false);
    productStage.mount(null);
    cleanupCreatedAssets();
    projectionToken += 1;
    if (unsubscribe) unsubscribe();
    if (resizeObserver) resizeObserver.disconnect();
    else window.removeEventListener('resize', handleCompactChange);
    editor.removeEventListener('click', handleClick);
    editor.removeEventListener('input', handleInput);
    editor.removeEventListener('change', handleChange);
    editor.removeEventListener('keydown', handleKeydown);
    editor.removeEventListener('pointerdown', handleEditorPointerDown);
    if (inspirationHelper) inspirationHelper.removeEventListener('toggle', handleInspirationToggle);
    document.removeEventListener('fullscreenchange', handleFullscreenChange);
    document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
    window.removeEventListener('pagehide', handlePageHide);
    setEditorPageScrolling(false);
    if (compactQuery) {
      if (compactQuery.removeEventListener) compactQuery.removeEventListener('change', handleCompactChange);
      else if (compactQuery.removeListener) compactQuery.removeListener(handleCompactChange);
    }
    destroyStages();
    configuratorRoot.removeAttribute('data-configurator-editor-initialized');
    configuratorRoot.configuratorEditor = null;
  }

  function handlePageHide(event) {
    if (!event.persisted) destroy();
  }

  editor.addEventListener('click', handleClick);
  editor.addEventListener('input', handleInput);
  editor.addEventListener('change', handleChange);
  editor.addEventListener('keydown', handleKeydown);
  editor.addEventListener('pointerdown', handleEditorPointerDown);
  if (inspirationHelper) inspirationHelper.addEventListener('toggle', handleInspirationToggle);
  document.addEventListener('fullscreenchange', handleFullscreenChange);
  document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
  window.addEventListener('pagehide', handlePageHide);
  if (compactQuery) {
    if (compactQuery.addEventListener) compactQuery.addEventListener('change', handleCompactChange);
    else if (compactQuery.addListener) compactQuery.addListener(handleCompactChange);
  }
  if (window.ResizeObserver) {
    resizeObserver = new ResizeObserver(function () {
      if (active) ['front', 'back'].forEach(fitStage);
    });
    resizeObserver.observe(editor);
  } else {
    window.addEventListener('resize', handleCompactChange);
  }
  unsubscribe = app.subscribe(handleAppState);

  configuratorRoot.configuratorEditor = {
    setActive: setActive,
    getState: function () {
      return {
        active: active,
        activeSide: activeSide,
        selectedId: selectedId,
        selectedIds: selectedIds.slice(),
        fullscreen: fullscreen,
        stageCount: (stages.front ? 1 : 0) + (stages.back ? 1 : 0),
        historyLength: history.length,
        historyIndex: historyIndex
      };
    },
    destroy: destroy
  };
}());
